import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { brandName, comparisonRows, keepImprovising, price, useTheSystem } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-navy py-14 sm:py-20" aria-labelledby="final-cta-heading" data-id="element-64" data-mp="3vsmbvwaizfzu">
      <div className="mx-auto max-w-5xl px-6" data-id="element-65" data-mp="2y5434lgv6dvu">
        <SectionHeading title={<span id="final-cta-heading" data-id="element-67" data-mp="2y2rczl0ycx7p">Your next training session</span>} data-id="element-66" data-mp="2y6f6wlab7lmy" />

        <div className="mt-10 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-68" data-mp="334gmgw8j12to">
          <div className="rounded-3xl border border-line bg-ink p-6 sm:p-7" data-id="element-69" data-mp="382rwp82qhfcf">
            <h3 className="font-display text-2xl font-extrabold uppercase text-fg" data-id="element-70" data-mp="3cti2gmf2nk7n">
              You can keep improvising...
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-71" data-mp="2fdl1ahykt5ve">
              {keepImprovising.map(item => <li key={item} className="flex items-start gap-2.5 leading-snug text-muted" data-id="element-72" data-mp="2kcnu941a7ln0">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-73" data-mp="2dcjidc48oaz4" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl border-2 border-accent/60 bg-panel p-6 sm:p-7" data-id="element-74" data-mp="23lxci9mbqytm">
            <h3 className="font-display text-2xl font-extrabold uppercase text-accent" data-id="element-75" data-mp="1yn3woajkevqa">
              Or use {brandName}
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-76" data-mp="1umjz55v2xq3m">
              {useTheSystem.map(item => <li key={item} className="flex items-start gap-2.5 font-medium leading-snug text-fg" data-id="element-77" data-mp="1pmp914j4p4jm">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-78" data-mp="1kn2tgoftvc7n" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl border border-line" data-id="element-79" data-mp="3f1voal8vzyyj">
          <table className="w-full table-fixed text-left" data-id="element-80" data-mp="3a29bgcwz0kq9">
            <thead data-id="element-81" data-mp="3a2sigyl31opi">
              <tr className="bg-ink" data-id="element-82" data-mp="3a06flc94zxdm">
                <th scope="col" className="px-4 py-4 font-display text-lg font-bold uppercase tracking-wide text-muted sm:px-6" data-id="element-83" data-mp="18cleybd0yeb8">
                  Keep improvising
                </th>
                <th scope="col" className="border-l border-line bg-accent/10 px-4 py-4 font-display text-lg font-bold uppercase tracking-wide text-accent sm:px-6" data-id="element-84" data-mp="yf79f6sn39xp">
                  {brandName}
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-85" data-mp="1r44da4w3t46x">
              {comparisonRows.map(row => <tr key={row.without} data-id="element-86" data-mp="1w1mltu67lhee">
                  <td className="px-4 py-3.5 align-top text-[0.95rem] leading-snug text-muted sm:px-6" data-id="element-87" data-mp="1w0bly5fvwtsk">
                    <span className="flex items-start gap-2" data-id="element-88" data-mp="1i5954n9i1k0z">
                      <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-89" data-mp="1m2x5i5tyo509" />
                      {row.without}
                    </span>
                  </td>
                  <td className="border-l border-line bg-accent/[0.05] px-4 py-3.5 align-top text-[0.95rem] font-medium leading-snug text-fg sm:px-6" data-id="element-90" data-mp="aqwcuftz7wf8">
                    <span className="flex items-start gap-2" data-id="element-91" data-mp="3ucddv47adzox">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-92" data-mp="3ubv73dn0032r" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-93" data-mp="3gli2nl9bf6i6">
          <p className="font-display text-2xl font-bold uppercase leading-tight text-muted sm:text-3xl" data-id="element-94" data-mp="3blvqzg94xybh">
            You do not need to be the perfect coach.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight text-fg sm:text-3xl" data-id="element-95" data-mp="3qcmhmkyzqrd0">
            You need a system that helps you plan faster, coach with structure,
            and develop players with consistency.
          </p>
          <p className="mt-10 font-display text-4xl font-extrabold uppercase leading-[0.95] text-accent sm:text-5xl" data-id="element-96" data-mp="2su2xlkq5mb38">
            Your next handball session is already planned.
          </p>

          <CtaButton size="large" className="mt-9 w-full sm:w-auto" data-id="element-97" data-mp="204kr7g76t9wd">
            Get {brandName} — {price}
          </CtaButton>
          <p className="mt-4 text-sm text-muted" data-id="element-98" data-mp="252w11qxhfkel">
            Secure payment · Instant access · 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}